import GQLRequest from 'utils/GQLRequest';
import { RawSheetsSettings, SheetsSettings } from 'records/SheetsSettings';

export const getSheetSettings = async (
  projectId: string
): Promise<SheetsSettings> => {
  const { sheetSettings } = await new GQLRequest()
    .query(
      `
      query SheetSettings($projectId: String!) {
        sheetSettings(projectId: $projectId) {
          setType: disciplineSetType
          disciplines {
              id
              designator
              description
              sortOrder
          }
        }
      }
      `
    )
    .variables({ projectId })
    .json<{
      sheetSettings: RawSheetsSettings;
    }>();

  return SheetsSettings.deserialize(sheetSettings);
};
